import { weightClasses } from "@/utils/topicStyles";

type Evidence = {
  type: string;
  title: string;
  desc: string;
  weight: string;
  source: string;
};

const typeIcons: Record<string, string> = {
  视频素材: "ri-video-line",
  视频回放: "ri-play-circle-line",
  音频: "ri-mic-line",
  音频比对: "ri-equalizer-line",
  截图: "ri-image-line",
  页面快照: "ri-window-line",
  文字: "ri-file-text-line",
  说明: "ri-file-text-line",
  元信息: "ri-information-line",
  配料表: "ri-list-check",
  检测报告: "ri-flask-line",
  记录: "ri-history-line",
  照片: "ri-image-line",
  对照: "ri-refresh-line",
  标准: "ri-bookmark-line",
  字体比对: "ri-font-size",
  公示数据: "ri-table-line",
};

export default function EvidenceList({ items }: { items: Evidence[] }) {
  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <article
          key={item.title}
          className="flex flex-col gap-3 rounded-lg border border-background-300 bg-background-100 p-5 sm:flex-row sm:items-start sm:gap-5"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-background-200 text-foreground-700">
            <i className={`${typeIcons[item.type] || "ri-file-line"} text-xl`} />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-label text-[11px] text-foreground-500">
                依据 {String(index + 1).padStart(2, "0")} · {item.type}
              </span>
              <span
                className={`rounded-md border px-2 py-0.5 font-label text-[11px] ${weightClasses(item.weight)}`}
              >
                强度 {item.weight}
              </span>
            </div>
            <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            <p className="mt-3 inline-flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
              <i className="ri-links-line" /> 来源：{item.source}
            </p>
          </div>
        </article>
      ))}
    </div>
  );
}